<template>
  <div id="DashboardSales" class="container is-fluid">
    <link href="https://fonts.googleapis.com/icon?family=Material+Icons"
      rel="stylesheet">

    <!-- Header -->
    <HeroContainer title="Sales Dashboard" />

    <section id="filters" style="display:flex; justify-content:center;">
      <div class="fields">
      <div class="field">
        <input id="switch_to_date" type="checkbox" name="switch_to_date" class="switch is-rounded is-info" checked="checked" v-model="to_date">
        <label for="switch_to_date" style="outline:none; margin-right:0.5rem; min-width">
          <span v-if="to_date">To date</span>
          <span v-else>All dates</span>
        </label>
      </div>
      <div class="select" style="margin-right:0.5rem">
        <select id="customer_select" v-model="filter_customer">
          <option value=''>All Customers</option>
          <option v-for="item in customer_items" :key="'cust_'+item" :value="item">{{item}}</option>
        </select>
      </div>
      <div class="select" style="margin-right:0.5rem">
        <select id="user_select" v-model="filter_user">
          <option value=''>All Sales Team</option>
          <option value='Dee'>Dee</option>
          <option value='Sandy'>Sandy</option>
          <option value='Angela'>Angela</option>
        </select>
      </div>
      <button id='filter_button' class="button is-info" type="button" @click="filter_summary_records">Search</button>
      </div>
    </section>

    <section style="display:flex; flex-direction:row; justify-content:space-evenly;">      
      <div id="Day" style="display:flex; flex-direction:column; justify-content:space-evenly;" >
        
        <div class="card" >
          <header class="card-header-title is-centered" style="flex-direction:column">
            <div class="title is-centered">
              Profit
            </div>
            <div class="subtitle is-centered">
              Day over Day
            </div>
          </header>
          <div class="card-content">
            <div class="total" v-bind:class="{small_num: is_down_p_day}">
              {{this.profit_total_today}}
            </div>
            <div class="percent_diff" v-bind:class="[is_down_p_day ? 'has-text-danger' : '', 'has-text-success']">
              <i v-if="is_down_p_day" 
                  class="material-icons"
                  >
                arrow_drop_down
              </i>
              <i v-else 
                  class="material-icons"
                  >
                arrow_drop_up
              </i>
              {{this.diff_profit_day}}
            </div>
            <div class="total" v-bind:class="{small_num: !is_down_p_day}">
              {{this.profit_total_yesterday}}
            </div>
          </div>
        </div>

        <div class="card" >
          <header class="card-header-title is-centered" style="flex-direction:column">
            <div class="title is-centered">
              Sales
            </div>
            <div class="subtitle is-centered">
              Day over Day
            </div>
          </header>
          <div class="card-content">
            <div class="total" v-bind:class="{small_num: is_down_s_day}">
              {{this.sales_total_today}}
            </div>
            <div class="percent_diff" v-bind:class="[is_down_s_day ? 'has-text-danger' : '', 'has-text-success']">
              <i v-if="is_down_s_day" 
                  class="material-icons"
                  >
                arrow_drop_down
              </i>
              <i v-else 
                  class="material-icons"
                  >
                arrow_drop_up
              </i>
              {{this.diff_sales_day}}
            </div>
            <div class="total" v-bind:class="{small_num: !is_down_s_day}">
              {{this.sales_total_yesterday}}
            </div>
          </div>
        </div>

        <div class="card">
          <header class="card-header-title is-centered" style="flex-direction:column">
            <div class="title is-centered">
              Quotes
            </div>
            <div class="subtitle is-centered">
              Day over Day
            </div>
          </header>
          <div class="card-content">
            <div class="total" v-bind:class="{small_num: is_down_q_day}">
              {{this.quote_total_today}}
            </div>
            <div class="percent_diff" v-bind:class="[is_down_q_day ? 'has-text-danger' : '', 'has-text-success']">
              <i v-if="is_down_q_day" 
                  class="material-icons"
                  >
                arrow_drop_down
              </i>
              <i v-else 
                  class="material-icons"
                  >
                arrow_drop_up
              </i>
              {{this.diff_quotes_day}}
            </div>
            <div class="total" v-bind:class="{small_num: !is_down_q_day}">
              {{this.quote_total_yesterday}}
            </div>
          </div>
        </div>

      </div>

      <div id="Month" style="display:flex; flex-direction:column; justify-content:space-evenly;" >

        <div class="card">
          <header class="card-header-title is-centered" style="flex-direction:column">
            <div class="title is-centered">
              Profit
            </div>
            <div class="subtitle is-centered">
              Month over Month
            </div>
          </header>
          <div class="card-content">
            <div class="total" v-bind:class="{small_num: is_down_p_month}">
              {{this.profit_total_month}}
            </div>
            <div class="percent_diff" v-bind:class="[is_down_p_month ? 'has-text-danger' : '', 'has-text-success']">
              <i v-if="is_down_p_month" 
                  class="material-icons"
                  >
                arrow_drop_down
              </i>
              <i v-else 
                  class="material-icons"
                  >
                arrow_drop_up
              </i>
              {{this.diff_profit_month}}
            </div>
            <div class="total" v-bind:class="{small_num: !is_down_p_month}">
              {{this.profit_total_month_last}}
            </div>
          </div>
        </div>

        <div class="card">
          <header class="card-header-title is-centered" style="flex-direction:column">
            <div class="title is-centered">
              Sales
            </div>
            <div class="subtitle is-centered">
              Month over Month
            </div>
          </header>
          <div class="card-content">
            <div class="total" v-bind:class="{small_num: is_down_s_month}">
              {{this.sales_total_month}}
            </div>
            <div class="percent_diff" v-bind:class="[is_down_s_month ? 'has-text-danger' : '', 'has-text-success']">
              <i v-if="is_down_s_month" 
                  class="material-icons"
                  >
                arrow_drop_down
              </i>
              <i v-else 
                  class="material-icons"
                  >
                arrow_drop_up
              </i>
              {{this.diff_sales_month}}
            </div>
            <div class="total" v-bind:class="{small_num: !is_down_s_month}">
              {{this.sales_total_month_last}}
            </div>
          </div>
        </div>

        <div class="card">
          <header class="card-header-title is-centered" style="flex-direction:column">
            <div class="title is-centered">
              Quotes
            </div>
            <div class="subtitle is-centered">
              Month over Month
            </div>
          </header>
          <div class="card-content">
            <div class="total" v-bind:class="{small_num: is_down_q_month}">
              {{this.quote_total_month}}
            </div>
            <div class="percent_diff" v-bind:class="[is_down_q_month ? 'has-text-danger' : '', 'has-text-success']">
              <i v-if="is_down_q_month" 
                  class="material-icons"
                  >
                arrow_drop_down
              </i>
              <i v-else 
                  class="material-icons"
                  >
                arrow_drop_up
              </i>
              {{this.diff_quotes_month}}
            </div>
            <div class="total" v-bind:class="{small_num: !is_down_q_month}">
              {{this.quote_total_month_last}}
            </div>
          </div>
        </div>

      </div>


      <div id="Year" style="display:flex; flex-direction:column; justify-content:space-evenly">

        <div class="card">
          <header class="card-header-title is-centered" style="flex-direction:column">
            <div class="title is-centered">
              Profit
            </div>
            <div class="subtitle is-centered">
              Year over Year
            </div>
          </header>
          <div class="card-content">
            <div class="total" v-bind:class="{small_num: is_down_p_year}">
              {{this.profit_total_year}}
            </div>
            <div class="percent_diff" v-bind:class="[is_down_p_year ? 'has-text-danger' : '', 'has-text-success']">
              <i v-if="is_down_p_year" 
                  class="material-icons"
                  >
                arrow_drop_down
              </i>
              <i v-else 
                  class="material-icons"
                  >
                arrow_drop_up
              </i>
              {{this.diff_profit_year}}
            </div>
            <div class="total" v-bind:class="{small_num: !is_down_p_year}">
              {{this.profit_total_year_last}}
            </div>
          </div>
        </div>

        <div class="card">
          <header class="card-header-title is-centered" style="flex-direction:column">
            <div class="title is-centered">
              Sales
            </div>
            <div class="subtitle is-centered">
              Year over Year
            </div>
          </header>
          <div class="card-content">
            <div class="total" v-bind:class="{small_num: is_down_s_year}">
              {{this.sales_total_year}}
            </div>
            <div class="percent_diff" v-bind:class="[is_down_s_year ? 'has-text-danger' : '', 'has-text-success']">
              <i v-if="is_down_s_year" 
                  class="material-icons"
                  >
                arrow_drop_down
              </i>
              <i v-else 
                  class="material-icons"
                  >
                arrow_drop_up
              </i>
              {{this.diff_sales_year}}
            </div>
            <div class="total" v-bind:class="{small_num: !is_down_s_year}">
              {{this.sales_total_year_last}}
            </div>
          </div>
        </div>

        <div class="card">
          <header class="card-header-title is-centered" style="flex-direction:column">
            <div class="title is-centered">
              Quotes
            </div>
            <div class="subtitle is-centered">
              Year over Year
            </div>
          </header>
          <div class="card-content">
            <div class="total" v-bind:class="{small_num: is_down_q_year}">
              {{this.quote_total_year}}
            </div>
            <div class="percent_diff" v-bind:class="[is_down_q_year ? 'has-text-danger' : '', 'has-text-success']">
              <i v-if="is_down_q_year" 
                  class="material-icons"
                  >
                arrow_drop_down
              </i>
              <i v-else 
                  class="material-icons"
                  >
                arrow_drop_up
              </i>
              {{this.diff_quotes_year}}
            </div>
            <div class="total" v-bind:class="{small_num: !is_down_q_year}">
              {{this.quote_total_year_last}}
            </div>
          </div>
        </div>

      </div>
    </section>
  </div>
</template>

<style scoped>
.card{
  margin: 3rem 0;
}
.total{
  font-size:2.5rem
}
.percent_diff{
  display: flex;
  justify-content: center;
  align-items: center;
}
.small_num{
  color:slategray;
}
</style>

<script>
import moment from 'moment';
var numeral = require('numeral');
import {
  DASHBOARD_SALES
} from '@/data/url';
import HeroContainer from '@/components/shared/HeroContainer.vue';
import { useDropdownsStore } from '@/stores/dropdownsStore'

export default {
  name: 'DashboardSales',
  components: {
    HeroContainer,
  },
  computed:{
    dropdownsStore(){
      return useDropdownsStore()
    },
    customer_items(){
      return this.dropdownsStore.customer
    },
    is_down_p_day: function(){
      return parseFloat(this.diff_profit_day)<0.0
    },
    is_down_p_month: function(){
      return parseFloat(this.diff_profit_month)<0.0
    },
    is_down_p_year: function(){
      return parseFloat(this.diff_profit_year)<0.0
    },
    is_down_q_day: function(){
      return parseFloat(this.diff_quotes_day)<0.0
    },
    is_down_q_month: function(){
      return parseFloat(this.diff_quotes_month)<0.0
    },
    is_down_q_year: function(){
      return parseFloat(this.diff_quotes_year)<0.0
    },
    is_down_s_day: function(){
      return parseFloat(this.diff_sales_day)<0.0
    },
    is_down_s_month: function(){
      return parseFloat(this.diff_sales_month)<0.0
    },
    is_down_s_year: function(){
      return parseFloat(this.diff_sales_year)<0.0
    },
  },
  data: function(){
    return {
      to_date: true,
      filter_customer: '',
      filter_user: '',
      profit_total_today: '$0.00',
      profit_total_yesterday: '$0.00',
      quote_total_today: '$0.00',
      quote_total_yesterday: '$0.00',
      sales_total_today: '$0.00',
      sales_total_yesterday: '$0.00',
      profit_total_month: '$0.00',
      profit_total_month_last: '$0.00',
      quote_total_month: '$0.00',
      quote_total_month_last: '$0.00',
      sales_total_month: '$0.00',
      sales_total_month_last: '$0.00',
      profit_total_year: '$0.00',
      profit_total_year_last: '$0.00',
      quote_total_year: '$0.00',
      quote_total_year_last: '$0.00',
      sales_total_year: '$0.00',
      sales_total_year_last: '$0.00',
      diff_profit_day: '$0.00',
      diff_quotes_day: '$0.00',
      diff_sales_day: '$0.00',
      diff_profit_month: '$0.00',
      diff_quotes_month: '$0.00',
      diff_sales_month: '$0.00',
      diff_profit_year: '$0.00',
      diff_quotes_year: '$0.00',
      diff_sales_year: '$0.00',
    };
  },
  mounted: function(){
    this.ajax_get_summary_dashboard(this.filter_customer, this.filter_user, this.to_date)
  },
  methods: {
    set_searching(is_searching){
      this.searchStore.set_ajax_searching(is_searching)
    },
    filter_summary_records(){
      this.ajax_get_summary_dashboard(this.filter_customer, this.filter_user, this.to_date)
    },
    ajax_get_summary_dashboard(customer, user, to_date){
      let url = DASHBOARD_SALES
      this.set_searching(true)
      let this_vue = this
      function clean_dash(this_vue, dashboard){
        dashboard['diff_profit_day'] = (dashboard['profit_total_today'] - dashboard['profit_total_yesterday'])/dashboard['profit_total_yesterday']
        dashboard['diff_quotes_day'] = (dashboard['quote_total_today'] - dashboard['quote_total_yesterday'])/dashboard['quote_total_yesterday']
        dashboard['diff_sales_day'] = (dashboard['sales_total_today'] - dashboard['sales_total_yesterday'])/dashboard['sales_total_yesterday']
        dashboard['diff_profit_month'] = (dashboard['profit_total_month'] - dashboard['profit_total_month_last'])/dashboard['profit_total_month_last']
        dashboard['diff_quotes_month'] = (dashboard['quote_total_month'] - dashboard['quote_total_month_last'])/dashboard['quote_total_month_last']
        dashboard['diff_sales_month'] = (dashboard['sales_total_month'] - dashboard['sales_total_month_last'])/dashboard['sales_total_month_last']
        dashboard['diff_profit_year'] = (dashboard['profit_total_year'] - dashboard['profit_total_year_last'])/dashboard['profit_total_year_last']
        dashboard['diff_quotes_year'] = (dashboard['quote_total_year'] - dashboard['quote_total_year_last'])/dashboard['quote_total_year_last']
        dashboard['diff_sales_year'] = (dashboard['sales_total_year'] - dashboard['sales_total_year_last'])/dashboard['sales_total_year_last']
        
        // Format strings and save to vue instance
        for(let key in dashboard){
          if(key.startsWith('diff')){
            // Check for NaN
            if(Number.isNaN(dashboard[key]) | !Number.isFinite(dashboard[key])){
              dashboard[key] = 0
            }
            // Format all percentages
            dashboard[key] = numeral(dashboard[key]).format('0,0,0,0,0%')
          }else{
            // Format all numbers
            dashboard[key] = numeral(dashboard[key]).format('$0,0,0,0,0')
          }
          
          // Save all numbers to Vue
          this_vue[key] = dashboard[key]
        }
      }
      fetch(url, {
        method:'POST',
        body: JSON.stringify({local_datetime: moment().toISOString(true), customer: customer, user: user, to_date: to_date,}),
      })
      .then(res => res.json())
      .then(res => {
        this_vue.set_searching(false)
        if (res.success){
          clean_dash(this_vue, res.dashboard)
        }
      })
      .catch(e => {
        this_vue.set_searching(false)
        console.error(JSON.stringify(e.message));
      });
    },
  }
};

</script>
